import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { captchaStatusType, IYaSmartCaptchaState } from '../types';

const initialState: IYaSmartCaptchaState = {
  token: null,
  forceReset: false,
  captchaStatus: 'wanted',
  isCaptchaNeed: true,
};

const yaSmartCaptchaSlice = createSlice({
  name: 'captcha',
  initialState,
  reducers: {
    setCaptchaToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setIsCaptchaNeed: (state, action: PayloadAction<boolean>) => {
      state.isCaptchaNeed = action.payload;
    },
    resetCaptcha: (state) => {
      state.token = null;
      state.captchaStatus = 'wanted';
    },
    setForceReset: (state) => {
      state.forceReset = !state.forceReset;
    },
    setCaptchaStatus: (state, action: PayloadAction<captchaStatusType>) => {
      state.captchaStatus = action.payload;
    },
  },
});

export const {
  setCaptchaToken,
  setIsCaptchaNeed,
  resetCaptcha,
  setCaptchaStatus,
  setForceReset,
} = yaSmartCaptchaSlice.actions;
export const yaSmartCaptchaReducer = yaSmartCaptchaSlice.reducer;
